module.exports = __webpack_public_path__ + "img/account-sets-white.4cd45f2a.svg";